import styled from "@emotion/styled";
import {
  MOBILE_SCREEN,
  FLEX_ROW,
  FLEX_COLUMN,
  SPACING,
  BORDER_RADIUS_MEDIUM,
  COLOR_FINANCIAL_ITEM_BACKGROUND,
  BOX_SHADOW_BUTTON,
  BOX_SHADOW_BUTTON_HOVER,
  BOX_SHADOW_LARGE,
} from "../../../components/theme";
import { CloseButton } from "../../../components/buttons/CloseButton";
import { ButtonContainer, Overlay } from "../../../components/popups/Popup";
import IconContainer from "../../../components/icons/IconContainer";
import { Card } from "../../../components/layout/Card";

export const CustomHeaderContainer = styled.div`
  margin-bottom: ${SPACING.LG};
  display: flex;
  gap: ${SPACING.MD};
  ${MOBILE_SCREEN} {
    margin-bottom: ${SPACING.MD};
  }
`;

export const HeaderRow = styled.div`
  ${FLEX_ROW}
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  width: 100%;
  gap: ${SPACING.LG};

  ${MOBILE_SCREEN} {
    flex-direction: column;
    align-items: flex-start;
    gap: ${SPACING.SM};
  }
`;

export const HeaderLeft = styled.div`
  ${FLEX_ROW}
  align-items: center;
  padding: 0px;
  width: 100%;
  gap: ${SPACING.MD};
`;

export const HeaderContent = styled.div`
  ${FLEX_COLUMN}
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
`;

export const QuestionSection = styled.div`
  ${FLEX_COLUMN}
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  gap: ${SPACING.LG};
  margin-bottom: ${SPACING.XL};

  ${MOBILE_SCREEN} {
    margin-bottom: ${SPACING.LG};
  }
`;

export const AnswersContainer = styled.div`
  ${FLEX_ROW}
  align-items: stretch;
  padding: 0px;
  width: 100%;
  gap: ${SPACING.MD};

  ${MOBILE_SCREEN} {
    flex-direction: column;
  }
`;

export const CardFooter = styled(ButtonContainer)`
  ${FLEX_ROW}
  align-items: center;
  padding: 0px;
  width: 100%;
  gap: ${SPACING.MD};

  > button {
    flex: 1;
    padding: 16px 32px; // make sure the buttons are the same size

    // prevent text wrapping on narrow screens
    @media screen and (max-width: 848px) {
      font-size: 14px;
      padding: 16px 16px;
    }
  }

  ${MOBILE_SCREEN} {
    flex-direction: column-reverse;
    gap: ${SPACING.SM};
    margin-top: ${SPACING.MD};

    > button {
      width: 100%;
      flex: none;
    }
  }
`;

export const StyledOverlay = styled(Overlay)`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  ${FLEX_COLUMN}
  position: sticky;
  top: 20vh;
  max-width: 808px;
  width: calc(100% - 48px);
  margin: ${SPACING.XL};
  border-radius: ${BORDER_RADIUS_MEDIUM};
  box-shadow: ${BOX_SHADOW_LARGE};
  overflow: visible;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  margin-bottom: ${SPACING.LG};
`;

export const StyledCloseButton = styled(CloseButton)`
  width: ${SPACING.XL};
  height: ${SPACING.XL};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  border-radius: 50%;
  box-shadow: ${BOX_SHADOW_BUTTON};
  transition: background-color 0.2s ease;

  &:hover {
    box-shadow: ${BOX_SHADOW_BUTTON_HOVER};
  }

  ${MOBILE_SCREEN} {
    display: none;
  }
`;

export const StyledIconContainer = styled(IconContainer)`
  flex-shrink: 0;
  min-width: 48px;
  min-height: 48px;
`;

export const StyledCard = styled(Card)`
  ${FLEX_COLUMN}
  overflow: visible;
  height: 100%;
`;

export const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  background-color: ${COLOR_FINANCIAL_ITEM_BACKGROUND};
  padding: 0 16px 16px 16px;
  border-radius: ${BORDER_RADIUS_MEDIUM};
  min-height: 0;

  ${MOBILE_SCREEN} {
    width: calc(100% + 16px);
    margin-left: -24px;
    border-radius: 0;
  }
`;
